import { render, staticRenderFns } from "./ChallengeSentModal.vue?vue&type=template&id=d1e8f9a4"
import script from "./ChallengeSentModal.vue?vue&type=script&lang=js"
export * from "./ChallengeSentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports